import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LegalBasis3BasicRolandDe } from '@flows/insurance/schemas'

const legal_employment_status = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('employment_status')]:
        BaseSchema_LegalBasis3BasicRolandDe.shape.employment_status,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.employment_status.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('employment_status'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:employment_status.options.employed',
            },
            value: 'employed',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:employment_status.options.self_employed',
            },
            value: 'self_employed',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:employment_status.options.state_employee',
            },
            value: 'state_employee',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:employment_status.options.retired',
            },
            value: 'retired',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:employment_status.options.unemployed',
            },
            value: 'unemployed',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:employment_status.options.student',
            },
            value: 'student',
          },
        ],
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.employment_status.info.text',
        },
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.employment_status.info.title',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'legal_previous_legal_insurance',
  }) as const satisfies AnyStepConfiguration

export default legal_employment_status
